import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import PropTypes from 'prop-types';
import LayoutMobile from './LayoutMobile/LayoutMobile';
import LayoutDesktop from './LayoutDesktop/LayoutDesktop';

export default function Layout({ isMobile, children, path }) {
  return isMobile ? <LayoutMobile path={path}>{children}</LayoutMobile> : <LayoutDesktop path={path}>{children}</LayoutDesktop>;
}

Layout.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  path: PropTypes.string.isRequired,
};
